import { ref } from 'vue'
import { useForm, useField } from 'vee-validate'
import { object, string } from 'yup'
import { useError } from './useError'
import router from '../router'
import axios from '../axios'
import Cookies from 'js-cookie'

const isLoginBtnDisabled = ref(false)

export const useAuth = () => {
  const { toggleShowError } = useError()
  const schema = object({
    email: string()
      .typeError('必須です')
      .required('必須です'),
    password: string()
      .typeError('必須です')
      .required('必須です')
      .min(6, '6文字以上でなければなりません'),
  })

  // Create a form context with the validation schema
  const { handleSubmit } = useForm({
    validationSchema: schema,
  })

  const {
    meta: emailMeta,
    value: email,
    errorMessage: emailError,
  } = useField('email', undefined, { initialValue: '' })
  const {
    meta: passwordMeta,
    value: password,
    errorMessage: passwordError,
  } = useField('password', undefined, { initialValue: '' })

  const passwordInputType = ref('password')
  const passwordInputType1 = ref('password')
  const passwordInputType2 = ref('password')
  const passwordInputType3 = ref('password')

  // login form handler
  // TODO : login POST request
  const login = handleSubmit(values => {
    isLoginBtnDisabled.value = true
    const payload = JSON.parse(JSON.stringify(values, null, 2))
    axios
      .post('/auth/login', {
        email: payload.email,
        password: payload.password,
      })
      .then(res => {
        Cookies.set('token', res.data.credential.access_token)
        router.push('/top')
      })
      .catch(error => {
        Cookies.remove('token')
        Cookies.remove('token', { path: '' })
        console.log(error)
        console.log(error.response.data.message)
        toggleShowError(true, 'auth')
      })
    isLoginBtnDisabled.value = false
  })

  const changePassword = obj => {
    axios.put('/auth/change-password', obj)
  }

  const logout = () => {
    Cookies.set('token', '')
    router.push('/auth')
  }

  // show or hide password by clicking eye icon
  const togglePasswordInputType = () => {
    passwordInputType.value == 'password'
      ? (passwordInputType.value = 'text')
      : (passwordInputType.value = 'password')
  }
  const togglePasswordInputType1 = () => {
    passwordInputType1.value == 'password'
      ? (passwordInputType1.value = 'text')
      : (passwordInputType1.value = 'password')
  }
  const togglePasswordInputType2 = () => {
    passwordInputType2.value == 'password'
      ? (passwordInputType2.value = 'text')
      : (passwordInputType2.value = 'password')
  }
  const togglePasswordInputType3 = () => {
    passwordInputType3.value == 'password'
      ? (passwordInputType3.value = 'text')
      : (passwordInputType3.value = 'password')
  }

  return {
    passwordInputType,
    passwordInputType1,
    passwordInputType2,
    passwordInputType3,
    email,
    emailMeta,
    emailError,
    password,
    passwordError,
    passwordMeta,
    login,
    togglePasswordInputType,
    togglePasswordInputType1,
    togglePasswordInputType2,
    togglePasswordInputType3,
    isLoginBtnDisabled,
    logout,
    changePassword,
  }
}
